import React from "react";
import { Link } from "react-router-dom";
import TermsConditions from "./TermsConditions";
import flag_peru from "../../../assets/images/icon/flag_peru.png";
import flag_mexico from "../../../assets/images/icon/flag_mexico.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const FooterMenuList = () => {
 const footerMenuContent = [
  // {
  //   id: 1,
  //   title: "Sobre PowerBizz",
  //   // colClass: "col-lg-2 col-md-3",
  //   colClass: "col-xxl-3 col-lg-3 col-md-4",
  //   list: [
  //     { name: "Nosotros", routeLink: "/" },
  //     { name: "Preguntas Frecuentes", routeLink: "/" },
  //   ],
  // },
  {
   id: 2,
   title: "Sedes:",
   colClass: "col-xxl-4 col-lg-4 col-md-6",
   list: [
    { name: "Perú", imageSrc: flag_peru },
    { name: "México", imageSrc: flag_mexico },
   ],
   hasImage: true,
  },
  {
   id: 3,
   title: "Contáctanos",
   colClass: "col-xxl-4 col-lg-4 col-md-6",
   list: [{ name: "contacto@powerbizz.com" }],
  },
 ];

 return (
  <>
   {footerMenuContent.map((menuItem) => (
    // <div className="col-xl-4 col-lg-4 mb-40"><div className="col-xl-4 col-lg-4 mb-40"></div>
    <div
     className={`${menuItem.colClass} col-sm-6 mb-40 d-flex flex-col`}
     style={{ width: "max-content" }}
     key={menuItem.id}
    >
     <h5 className="title Zpr-[55px]">{menuItem.title}</h5>
     <ul className="footer-list style-none">
      {menuItem.list.map((list, i) => (
       <li key={i}>
        {menuItem.hasImage ? (
         <div className="flex items-center gap-2">
          <LazyLoadImage src={list.imageSrc} alt="icon" className="h-5 w-5" />
          <a href={list.routeLink} target="_blank">
           {list.name}
           <span className="pl-2 align-center text-base text-purple-600">
            •
           </span>
          </a>
         </div>
        ) : (
         <a href={list.routeLink} target="_blank">
          {list.name}
         </a>
        )}
       </li>
      ))}
     </ul>
    </div>
   ))}
  </>
 );
};

export default FooterMenuList;
